export const UPLOAD_LIMITS = {
  image: 5,
  video: 50,
  audio: 10,
  pdf: 10,
};

export const mbToBytes = (mb) => mb * 1024 * 1024;
